export const getCrossBrowserElement = mouseEvent => {
  const result = {
    x: 0,
    y: 0
  };

  if (!mouseEvent) {
    mouseEvent = window.event;
  }

  if (mouseEvent.pageX || mouseEvent.pageY) {
    result.x = mouseEvent.pageX;
    result.y = mouseEvent.pageY;
  } else if (mouseEvent.clientX || mouseEvent.clientY) {
    result.x =
      mouseEvent.clientX +
      document.body.scrollLeft +
      document.documentElement.scrollLeft;
    result.y =
      mouseEvent.clientY +
      document.body.scrollTop +
      document.documentElement.scrollTop;
  }

  return result;
};

export const getClientWidth = className => {
  return document.getElementsByClassName(className)[0].clientWidth;
};

// export const getDomain = (url: string): any => {
//   let domains = [
//     {
//       domain: "e.ausnutria.com",
//       secret:
//         "FbyhVFaYoWdtXAMItzRPuexSANAaGD8SH0CuljHwjJWjGZbwmQCxcx2NoZJ74vRO",
//       corpID: "wxbaa80479dd64524f"
//     },
//     {
//       domain: "e.allnutria.com",
//       secret:
//         "FbyhVFaYoWdtXAMItzRPuexSANAaGD8SH0CuljHwjJWjGZbwmQCxcx2NoZJ74vRO",
//       corpID: "wxbaa80479dd64524f"
//     },
//     {
//       domain: "e.kabrita.com.cn",
//       secret:
//         "o4kn90z_lAYL_uwtbdOe7QDIPkll0Ei3oSvJlS7sfjfF_HBRF_hCqM6xT6CPvY3Y",
//       corpID: "wx98aaf1e2d2a6dd20"
//     },
//     {
//       domain: "e.1897.com",
//       secret:
//         "FKyiVTUBVwS9A2F1JIg7fvIb2vIjyb09rSI4uE0htlR-48EJATc16J3PiMGEUpS7",
//       corpID: "wx066844a6a8ebb6bd"
//     },
//     {
//       domain: "e.globlait.com",
//       secret:
//         "Hr97TxCUDXM22mk41nMjbtz2jXOaw32pZBpwGlFf0KnC_tlreddk9w0Ku5mD9Q3m",
//       corpID: "wxadebb5bedca9afb3"
//     },
//     {
//       domain: "e.puredo.com",
//       secret:
//         "GMx8hpExLVnA2w9U35pKrJLqAwOwoHc4FImWrXeMFtcH8UmD6Pzw85okxH7UklcG",
//       corpID: "wxd677da1f8ff44979"
//     },
//     {
//       domain: "localhost",
//       secret:
//         "FbyhVFaYoWdtXAMItzRPuexSANAaGD8SH0CuljHwjJWjGZbwmQCxcx2NoZJ74vRO",
//       corpID: "wxbaa80479dd64524f"
//     }
//   ];
//   let returnData;
//   domains.map(item => {
//     if (item.domain === url) {
//       returnData = item;
//     }
//   });
//   return returnData;
// };



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/service.ts